var exports = {
  "K": "pendingBody__aM6az7",
};

module.exports = exports;
